<div class="region-manager-manager">
  @if (regionManagerViewModel().isFetching || sourcesViewModel().isFetching) {
    <div class="region-manager-loading">
      <tds-icon name="progress_activity" class="spinner" data-testid="spinner" />
      <span>Loading...</span>
    </div>
  } @else {
    @for (source of whiteListedSources(); track source.id) {
      <app-region-manager-section
        [source]="source"
        [marketAreas]="marketAreasViewModel().marketAreas"
        [regionManagers]="regionManagerViewModel().regionManagers"
        [users]="analystViewModel().users"
      ></app-region-manager-section>
    } @empty {
      <p>No source configured.</p>
    }
  }
</div>
